import isEqual from 'lodash/isEqual'

import { useHistoricalDataAccess } from '@/utils/authorization/historical-data-access'
import maDate from '@/base/MaDate'

export async function maDateRangeGuard(to, from, next) {
  const { checkHistoricalDataAccess } = useHistoricalDataAccess()
  const queryClone = { ...to.query }

  const today = maDate().formatISODate()
  const lastDisabledDayCount = to.meta?.lastDisabledDayCount
  const validEndDate = typeof lastDisabledDayCount === 'number'
    ? maDate().subtract(lastDisabledDayCount, 'days').formatISODate()
    : today

  // Helper function to validate query params if they exist
  const validateDate = async (key, validValue, checkHistoricalAccess = false) => {
    if (queryClone[key]) {
      if (queryClone[key] > validValue) {
        queryClone[key] = validValue
      }
      if (checkHistoricalAccess) {
        const isValid = await checkHistoricalDataAccess(queryClone[key], to.meta.productFamily)
        if (!isValid) {
          queryClone[key] = validValue
        }
      }
    }
  }

  // Validate existing endDate
  await validateDate('endDate', validEndDate, true)

  // Validate existing startDate if present
  if (queryClone.startDate && queryClone.endDate) {
    const checkAccess = await checkHistoricalDataAccess(queryClone.startDate, to.meta.productFamily)
    if (!checkAccess || queryClone.startDate >= queryClone.endDate) {
      queryClone.startDate = maDate(validEndDate).subtract(6, 'days').formatISODate()
      queryClone.endDate = validEndDate
    }
  }
  else if (queryClone.startDate && !queryClone.endDate) {
    const checkAccess = await checkHistoricalDataAccess(queryClone.startDate, to.meta.productFamily)
    if (!checkAccess) {
      queryClone.startDate = maDate(validEndDate).subtract(6, 'days').formatISODate()
    }
  }

  // Validate existing date field
  await validateDate('date', today, true)

  if (!isEqual(to.query, queryClone)) {
    to.query = queryClone
    next(to)
  }
  else {
    next()
  }
}
